import React, { useEffect, useRef, useState } from "react";
import "./Certificates.css";

import cert1 from "../images/certificate1.jpg";
import cert2 from "../images/certificate2.jpg";
import cert3 from "../images/certificate3.jpg";
import cert4 from "../images/certificate4.jpg";
import cert5 from "../images/certificate5.jpg";
import cert6 from "../images/certificate6.jpg";
import cert7 from "../images/certificate7.jpg";
import cert8 from "../images/certificate8.jpg";
import cert9 from "../images/certificate9.jpg";
import cert10 from "../images/certificate10.jpg";
import cert11 from "../images/certificate11.jpg";

const certificates = [
  { title: "मान्यता प्रमाणपत्र", img: cert1 },
  { title: "पंजीकरण प्रमाणपत्र", img: cert2 },
  { title: "शुभ संदेश (चंद्रकांत पाटील)", img: cert3 },
  { title: "आयकर आयुक्त मान्यता प्रमाणपत्र", img: cert4 },
  { title: "नोंदणी प्रमाणपत्र", img: cert5 },
  { title: "नोंदणी प्रमाणपत्र", img: cert6 },
  { title: "आयएसओ प्रमाणपत्र", img: cert7 },
  { title: "एल.ई.आय. प्रमाणपत्र", img: cert8 },
  { title: "नोंदणीचे प्रमाणपत्र", img: cert9 },
  { title: "महा एन.जी.ओ. नोंदणी प्रमाणपत्र", img: cert10 },
  { title: "नीती आयोग प्रमाणपत्र", img: cert11 },
];

const Certificates = () => {
  const sliderRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (!slider) return;

      scrollAmount += 220;

      if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
        scrollAmount = 0;
      }

      slider.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const openImage = (img) => {
    setSelectedImage(img);
    setZoom(1);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setZoom(1);
  };

  const zoomIn = () => {
    setZoom((prev) => prev + 0.2);
  };

  const zoomOut = () => {
    setZoom((prev) => (prev > 1 ? prev - 0.2 : 1));
  };

  return (
    <section className="certificates-section">
      <h2>“प्रमाणपत्रे”</h2>

      <div className="certificates-slider" ref={sliderRef}>
        {certificates.map((item, index) => (
          <div className="certificate-card" key={index}>
            <img
              src={item.img}
              alt={item.title}
              onClick={() => openImage(item.img)}
            />
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      {/* POPUP MODAL */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closeImage}>
              ✕
            </button>

            <img
              src={selectedImage}
              alt="certificate-popup"
              style={{ transform: `scale(${zoom})` }}
            />

            <div className="zoom-controls">
              <button onClick={zoomOut}>−</button>
              <button onClick={zoomIn}>+</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certificates;